import user from './user';
import login from './login';
import lesson from './lesson';
import group from './group';

// eslint-disable-next-line
export default {
  user,
  login,
  lesson,
  group,
};